import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import web5 from "../img/custom.jpg";
import "../style/styles.css";
import "../style/Custom.css";

const Custom = () => {
  const alText = "Photo";

  const customText =
    "A quality assurance software provider, EBS Software Solution offers custom software development utilizing appropriate software development methodologies. We provide software solutions that are advantageous to our clients. We are able to offer you a suitable resolution for your present and future application requirements and needs.We pledge to provide the best possible customer service by providing software development of the highest caliber.Web application development, customized e-commerce software, and other IT-enabled services. We have the newest tools and approaches for software development.Most of the time, standard software cannot meet all of your business needs. Most software bundles, even the best fit ones, will likely satisfy only 70% of your true needs. Standard software either doesn't fulfill all your needs, or the more expensive versions have features you'll never need. Therefore, why give in to something that isn't right for you? We offer our customers precisely the customized software solutions that will satisfy their unique business needs. Our group of skilled and knowledgeable engineers will incorporate application growth in your field of expertise. Our standardized software development process enables us to offer software solutions to almost any industry at a reasonable cost. This guarantees that the product you receive will be reliable and error-free, giving you the advantage over your rivals that you so richly deserve. We have a feedback policy in place because we recognize how important it is to communicate and provide client support. This guarantees that any inquiry or request will get a prompt response.We also focus on keeping you informed about the progress of your project by sending you scheduled reports and updates.Since it can be challenging for smaller businesses to afford dependable specialized software and programming services, we provide a professional package that is adaptable, economical, and can be customized to fit most budgets.";

  const highlights = [
    {
      value: "Custom",
      label: "Software Development",
    },
    {
      value: "QA",
      label: "Quality Assurance",
    },
    {
      value: "70%",
      label: "True Needs Gap",
    },
    {
      value: "Budget",
      label: "Friendly Package",
    },
  ];

  const serviceCards = [
    {
      title: "Custom Software Development",
      text:
        "We provide customized software solutions that satisfy unique business needs and support present and future application requirements.",
    },
    {
      title: "Web Application Development",
      text:
        "We deliver web application development, customized e-commerce software and other IT-enabled services with updated tools and approaches.",
    },
    {
      title: "Reliable & Error-free Solutions",
      text:
        "Our standardized software development process helps us provide reliable and error-free solutions to almost any industry at a reasonable cost.",
    },
    {
      title: "Communication & Support",
      text:
        "Our feedback policy, scheduled reports and project updates help keep clients informed and ensure prompt response to inquiries.",
    },
  ];

  const processItems = [
    "Understand present and future application requirements",
    "Plan appropriate software development methodologies",
    "Develop customized software according to business needs",
    "Test for reliability and error-free performance",
    "Share scheduled reports and project updates",
    "Provide adaptable and economical support packages",
  ];

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="custom-detail-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Customized Software Development | EBS Software Solution</title>
        <meta
          name="description"
          content="Customized software development by EBS Software Solution for web applications, customized e-commerce software, IT-enabled services, reliable software solutions and business-specific application requirements."
        />
      </Helmet>

      <section className="custom-hero">
        <div className="custom-hero-overlay"></div>

        <Container className="custom-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="custom-hero-content">
                <div className="custom-kicker">Business-Specific Software Solution</div>
                <h1>Customized Software Development</h1>
                <p>
                  A quality assurance software provider, EBS Software Solution
                  offers custom software development utilizing appropriate
                  software development methodologies.
                </p>
              </div>
            </Col>

            <Col lg={5}>
              <div className="custom-hero-card">
                <span>Why Custom Software?</span>
                <strong>Built around your exact business requirement</strong>
                <p>
                  Standard software may not fulfill all your needs. We provide
                  adaptable, economical and customized packages for business
                  requirements.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="custom-stats-section">
        <Container>
          <Row className="g-3">
            {highlights.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="custom-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="custom-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="custom-section-label">Overview</div>
              <h2 className="custom-section-title">
                Software designed for your unique business needs
              </h2>

              <p className="custom-text">
                We provide software solutions that are advantageous to our
                clients. We are able to offer you a suitable resolution for your
                present and future application requirements and needs.
              </p>

              <p className="custom-text">
                We pledge to provide the best possible customer service by
                providing software development of the highest caliber. Web
                application development, customized e-commerce software, and
                other IT-enabled services are supported with the newest tools
                and approaches.
              </p>
            </Col>

            <Col lg={6}>
              <div className="custom-image-card">
                <img
                  className="custom-main-image"
                  src={web5}
                  alt={alText}
                  onError={handleImageError}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="custom-content-section">
        <Container>
          <Row className="g-4 align-items-stretch">
            <Col lg={7}>
              <div className="custom-content-card">
                <div className="custom-section-label">Complete Information</div>
                <h2>Customized Software Development</h2>
                <p>{customText}</p>
              </div>
            </Col>

            <Col lg={5}>
              <div className="custom-service-grid">
                {serviceCards.map((item) => (
                  <div className="custom-service-card" key={item.title}>
                    <span>✓</span>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="custom-process-section">
        <Container>
          <div className="custom-process-card">
            <Row className="g-4 align-items-center">
              <Col lg={5}>
                <div className="custom-section-label">Development Process</div>
                <h2>Professional, adaptable and economical development approach</h2>
                <p>
                  We focus on communication, scheduled reports, project updates,
                  client support and a standardized software development process.
                </p>
              </Col>

              <Col lg={7}>
                <div className="custom-process-list">
                  {processItems.map((item) => (
                    <div key={item}>
                      <span>✓</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Custom;
